import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Tonnage } from '@classes/tonnage';
import { TonnageGridViewItem } from '@classes/tonnage-grid-view-item';
import { TonnageService } from 'app/core/services/tonnage.service';
import { UiService } from 'app/core/services/ui.service';
import { TonnageComponent } from 'app/modules/tonnage/pages/tonnage/tonnage.component';
import * as _moment from 'moment';
import { SelectionModel } from '@angular/cdk/collections';

// import { environment } from '@environments/environment';
import { ErrorMessageData } from '@classes/error-message-data';
import { ErrorMessageComponent } from '@components/error-message/error-message.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ArrayToExcel } from 'app/core/services/export-table.service';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

const moment = _moment;
@Component({
  selector: 'app-tonnage-grid',
  templateUrl: './tonnage-grid.component.html',
  styleUrls: ['./tonnage-grid.component.scss']
})
export class TonnageGridComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  environmentName = this.environment.application;
  dataSource = new MatTableDataSource<TonnageGridViewItem>();
  selection = new SelectionModel<TonnageGridViewItem>(true, []);
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'select',
    'siteName',
    'companyName',
    'date',
    'type',
    'shipName',
    'isExceptionalConvoy',
    'from',
    'to',
    'quantity',
    'material',
    'creationDate',
    'error',
    'action',
  ];

  tonnageGridFilterForm: FormGroup;
  filterLabel = "";


  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("tonnageFilterExpansionPanel", { static: true }) expansionPanel: MatExpansionPanel;


  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public tonnageService: TonnageService,
    public uiService: UiService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public envConfigurationService: EnvConfigurationService
  ) { }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'type': return (element.isLoading);
        case 'error': return (element.isError);
        default: return element[property];
      }
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
    this.getUrlParam();
    // this.getTonnages();
    this.onFilter();
  }

  getUrlParam() {
    if (this.route.snapshot.queryParams.selectedTab == null || parseInt(this.route.snapshot.queryParams.selectedTab) == 0) {
      const value = this.route.snapshot.queryParams;
      let param: any = {
        range: {}
      };
      if (value.companyId != null) {
        param.companyId = value.companyId;
        param.companyName = value.companyName;
      }
      if (value.siteId != null) {
        param.siteId = value.siteId;
        param.siteName = value.siteName;
      }
      if (value.start != null) {
        if (moment(value.start, "DD/MM/YYYY").isValid()) {
          param.start = moment(value.start, "DD/MM/YYYY");
        }
      }
      else {
        param.start = moment().add(-1, 'months')
      }
      if (value.end != null) {
        if (moment(value.end, "DD/MM/YYYY").isValid()) {
          param.end = moment(value.end, "DD/MM/YYYY");
        }
      }
      else {
        param.end = moment().add(1, 'months')
      }
      if (value.materialId != null) {
        param.materialId = value.materialId;
        param.materialName = value.materialName;
      }
      if (value.fromId != null) {
        param.fromId = value.fromId;
        param.fromName = value.fromName;
      }
      if (value.toId != null) {
        param.toId = value.toId;
        param.toName = value.toName;
      }
      if (value.shipId != null) {
        param.shipId = value.shipId;
        param.shipName = value.shipName;
      }
      if (value.isError != null) {
        param.isError = value.isError;
      }
      if (value.billed != null) {
        param.billed = value.billed;
      }
      if (value.isExceptionalConvoy != null) {
        param.isExceptionalConvoy = value.isExceptionalConvoy;
      }
      if (value.isLoading != null) {
        param.isLoading = value.isLoading;
      }
      this.initFilterForm(param);
      //this.tabGroup.selectedIndex = parseInt(this.route.snapshot.queryParams.selectedTab);
    } else {
      this.initFilterForm();
    }
  }

  exportExcel() {
    ArrayToExcel.exportArrayToExcel(this.selection.selected.filter(f => this.dataSource.filteredData.map(m => m.id).includes(f.id)).map(m => {
      return {
        Site: m.siteName,
        Société: m.companyName,
        Date: moment(m.date).format("DD/MM/YYYY"),
        Type: m.isLoading ? 'Chargement' : 'Déchargement',
        Bateau: m.shipName,
        Convoi_exceptionnel: m.isExceptionalConvoy ? 'Oui' : 'Non',
        Origine: m.from,
        Destination: m.to,
        Quantité: m.quantity,
        Matériau: m.material,
        Encodage: moment(m.creationDate).format("DD/MM/YYYY HH:mm")
      }
    }), 'Historique_Fluvial')
  }

  private initFilterForm(filter?: any) {
    const fb = this.formBuilder;
    this.tonnageGridFilterForm = fb.group({
      site: fb.control((filter && filter.siteId != null) ? { id: filter.siteId, name: filter.siteName } : null),
      company: fb.control((filter && filter.companyId != null) ? { id: filter.companyId, name: filter.companyName } : null),
      isLoading: fb.control((filter && filter.isLoading != null) ? filter.isLoading : ""),
      billed: fb.control((filter && filter.billed != null) ? filter.billed : ""),
      isExceptionalConvoy: fb.control((filter && filter.isExceptionalConvoy) != null ? filter.isExceptionalConvoy : ""),
      ship: fb.control((filter && filter.shipId != null) ? { id: filter.shipId, name: filter.shipName } : null),
      material: fb.control((filter && filter.materialId != null) ? { id: filter.materialId, name: filter.materialName } : null),
      range: fb.group({
        start: fb.control((filter && filter.start != null) ? filter.start : null),
        end: fb.control((filter && filter.end != null) ? filter.end : null)
      }),
      from: fb.control((filter && filter.fromId != null) ? { id: filter.fromId, name: filter.fromName } : null),
      to: fb.control((filter && filter.toId != null) ? { id: filter.toId, name: filter.toName } : null),
      isError: fb.control((filter && filter.isError != null) ? filter.isError : ""),
    });
  }
  private setFilterFormUrl() {
    if (this.route.snapshot.queryParams.selectedTab == null || parseInt(this.route.snapshot.queryParams.selectedTab) == 0) {
      const value = this.tonnageGridFilterForm.value;
      const formatUrlParam = (value: any): object => {
        let param: any = {};
        param.selectedTab = this.route.snapshot.queryParams.selectedTab || 0;
        if (value.company != null) {
          param.companyId = value.company.id;
          param.companyName = value.company.name;
        }
        if (value.site != null) {
          param.siteId = value.site.id;
          param.siteName = value.site.name;
        }
        if (value.range != null && value.range.start != null) {
          param.start = value.range.start.format('DD/MM/YYYY');
        }
        else {
          param.start = "null";
        }
        if (value.range != null && value.range.end != null) {
          param.end = value.range.end.format('DD/MM/YYYY');
        }
        else {
          param.end = "null";
        }
        if (value.material != null) {
          param.materialId = value.material.id;
          param.materialName = value.material.name;
        }
        if (value.from != null) {
          param.fromId = value.from.id;
          param.fromName = value.from.name;
        }
        if (value.to != null) {
          param.toId = value.to.id;
          param.toName = value.to.name;
        }
        if (value.ship != null) {
          param.shipId = value.ship.id;
          param.shipName = value.ship.name;
        }
        if (value.billed != "") {
          param.billed = value.billed;
        }
        if (value.isError != "") {
          param.isError = value.isError;
        }
        if (value.isExceptionalConvoy != "") {
          param.isExceptionalConvoy = value.isExceptionalConvoy;
        }
        if (value.isLoading != "") {
          param.isLoading = value.isLoading;
        }

        return param;
      }

      const queryParams = formatUrlParam(value);
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams
        }
      ).toString();
      this.location.go(url);
      this.route.snapshot.queryParams = queryParams;
    }
  }


  getTonnages() {
    this.uiService.addRouteLoading();
    const filterValue = this.tonnageGridFilterForm.value;
    this.tonnageService.getTonnages(filterValue.range.start, filterValue.range.end).subscribe(data => {
      this.selection.clear();
      this.dataSource.data = data.map(m => new TonnageGridViewItem({
        id: m.id,
        siteName: m.site?.name,
        siteId: m.site?.id,
        companyName: m.company?.name,
        companyId: m.company?.id,
        date: moment(m.date).toDate(),
        shipName: m.shipName,
        shipId: m.ship?.id,
        isLoading: m.isLoading,
        quantity: m.quantity,
        material: m.material?.name,
        materialId: m.material?.id,
        creationDate: moment(m.creationDate).toDate(),
        isExceptionalConvoy: m.isExceptionalConvoy,
        from: m.origineName,
        fromId: m.origineSite?.id,
        to: m.destinationName,
        toId: m.destinationSite?.id,
        tonnage: m,
        isError: m.isError,
        billed: m.billed
      }));
      this.selection.select(...this.dataSource.filteredData);
      this.uiService.removeRouteLoading();
    }, error => {
      this.uiService.removeRouteLoading();
      console.error(error);
    });

  }

  selectItemClick(item: TonnageGridViewItem) {
    this.selectedRowID = item.id || '';
  }

  onEdit(item: TonnageGridViewItem) {
    const data = item.tonnage;
    const dialogRef = this.dialog.open(TonnageComponent, {
      data,
      hasBackdrop: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(refresh => {
      if (refresh) {
        this.getTonnages();
      }
    })
  }
  onReportAnError(item: TonnageGridViewItem) {
    const data = new ErrorMessageData({
      tonnageID: item.id,
      isReport: true,
      isInError: item.isError,
    });
    const dialogRef = this.dialog.open(ErrorMessageComponent, {
      data,
      hasBackdrop: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.getTonnages();
      }
    })
  }

  onErrorClick(item: TonnageGridViewItem) {
    const data = new ErrorMessageData({
      tonnageID: item.id,
      isReport: false,
      isInError: item.isError,
    });
    const dialogRef = this.dialog.open(ErrorMessageComponent, {
      data,
      hasBackdrop: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.getTonnages();
      }
    })
  }

  onFilter() {
    this.dataSource.filter = JSON.stringify(this.tonnageGridFilterForm.value);
    this.initFilterLabel();
    this.setFilterFormUrl();
    this.expansionPanel.close();
    this.getTonnages();
  }
  onClearFilter() {
    this.initFilterForm();
    this.initFilterLabel();
    this.onFilter();
    this.setFilterFormUrl();
    this.getTonnages();
  }
  createFilter(): (data: TonnageGridViewItem, filter: string) => boolean {
    let filterFunction = function (data: TonnageGridViewItem,
      filter: string
    ): boolean {
      let searchTerms = JSON.parse(filter);
      const filterValue =
        ((typeof searchTerms.site == "object" && searchTerms.site) ? data.siteId == searchTerms.site.id : true)
        && ((typeof searchTerms.company == "object" && searchTerms.company) ? data.companyId == searchTerms.company.id : true)
        && (searchTerms.isLoading != "" ? data.isLoading == (searchTerms.isLoading == "true") : true)
        && (searchTerms.isError != "" ? data.isError == (searchTerms.isError == "true") : true)
        && (searchTerms.isExceptionalConvoy != "" ? data.isExceptionalConvoy == (searchTerms.isExceptionalConvoy == "true") : true)
        && (searchTerms.billed != "" ? data.billed == (searchTerms.billed == "true") : true)
        && ((typeof searchTerms.ship == "object" && searchTerms.ship) ? data.shipId == searchTerms.ship.id : true)
        && ((typeof searchTerms.from == "object" && searchTerms.from) ? data.fromId == searchTerms.from.id : true)
        && ((typeof searchTerms.to == "object" && searchTerms.to) ? data.toId == searchTerms.to.id : true)
        && ((searchTerms.range != null && searchTerms.range.start != null) ? moment(data.date).isSameOrAfter(moment(searchTerms.range.start)) : true)
        && ((searchTerms.range != null && searchTerms.range.end != null) ? moment(data.date).isSameOrBefore(moment(searchTerms.range.end)) : true)
        && ((typeof searchTerms.material == "object" && searchTerms.material) ? data.materialId == searchTerms.material.id : true)
        ;
      return filterValue;
    }
    return filterFunction;
  }
  initFilterLabel() {
    this.filterLabel = "";
    const addSeparator = () => {
      if (this.filterLabel.length > 0) {
        this.filterLabel += " | "
      }
    }
    const filterValue = this.tonnageGridFilterForm.value;
    if (typeof filterValue.site == "object" && filterValue.site) {
      addSeparator();
      this.filterLabel += ("Site : " + filterValue.site.name);
    }
    if (typeof filterValue.company == "object" && filterValue.company) {
      addSeparator();
      this.filterLabel += ("Société : " + filterValue.company.name);
    }
    if (filterValue.range != null && filterValue.range.start != null) {
      addSeparator();
      this.filterLabel += ("Du : " + (filterValue.range.start.format('DD/MM/YYYY')));
    }
    if (filterValue.range != null && filterValue.range.end != null) {
      addSeparator();
      this.filterLabel += ("Au : " + (filterValue.range.end.format('DD/MM/YYYY')));
    }
    if (filterValue.isLoading != "") {
      addSeparator();
      this.filterLabel += ("Type : " + (filterValue.isLoading == "true" ? "Chargement" : "Déchargement"));
    }
    if (filterValue.isExceptionalConvoy != "") {
      addSeparator();
      this.filterLabel += ("Convoi exceptionnel : " + (filterValue.isExceptionalConvoy == "true" ? "Oui" : "Non"));
    }
    if (typeof filterValue.ship == "object" && filterValue.ship) {
      addSeparator();
      this.filterLabel += ("Bateau : " + filterValue.ship.name);
    }
    if (typeof filterValue.from == "object" && filterValue.from) {
      addSeparator();
      this.filterLabel += ("Origine : " + filterValue.from.name);
    }
    if (typeof filterValue.to == "object" && filterValue.to) {
      addSeparator();
      this.filterLabel += ("Destination : " + filterValue.to.name);
    }
    if (typeof filterValue.material == "object" && filterValue.material) {
      addSeparator();
      this.filterLabel += ("Matériau : " + filterValue.material.name);
    }
    if (filterValue.billed != "") {
      addSeparator();
      this.filterLabel += ("Facturé : " + (filterValue.billed == "true" ? "Oui" : "Non"));
    }
    if (filterValue.isError != "") {
      addSeparator();
      this.filterLabel += ("En erreur : " + (filterValue.isError == "true" ? "Oui" : "Non"));
    }
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }
}
